import { storeToRefs } from 'pinia';
import { useModal } from 'vue-final-modal';
import DangerIcon from '@/shared/assets/icons/DangerIcon.svg';
import ConfirmDeleteModal from '@/shared/ui/modals/ConfirmDeleteModal.vue';

import {
  PERMISSION_COPY_SUCCESS_MESSAGE,
  PERMISSION_PASTE_ERROR_MESSAGE,
  PERMISSION_PASTE_SUCCESS_MESSAGE,
  permissionPasteReplaceTitle,
} from '../lib/permission-subject-filters';
import { useFormBuilderStore } from '../model/form-builder.store';
import { useFormPermissionsSelectionStore } from '../model/form-permissions-selection.store';
import { useFormPermissionsStore } from '../model/form-permissions.store';

import { useFormBuilderToast } from './useFormBuilderToast';

export function usePermissionsClipboard() {
  const formBuilderStore = useFormBuilderStore();
  const selectionStore = useFormPermissionsSelectionStore();
  const permissionsStore = useFormPermissionsStore();
  const { canCopy, canPaste } = storeToRefs(selectionStore);
  const { showSuccessToast, showErrorToast } = useFormBuilderToast();

  function copy() {
    if (!selectionStore.copy()) return;

    showSuccessToast({ title: PERMISSION_COPY_SUCCESS_MESSAGE, type: 'success' });
  }

  function commitPaste() {
    const clipboard = selectionStore.clipboard;
    const targets = selectionStore.resolvePasteTargets(formBuilderStore.elements);
    if (!clipboard || targets.length === 0) return;

    try {
      selectionStore.recordChange(() =>
        permissionsStore.applyToFields(targets, {
          positionIds: clipboard.positionIds,
          functionalActivityIds: clipboard.functionalActivityIds,
        })
      );
      selectionStore.finishPaste();
      showSuccessToast({ title: PERMISSION_PASTE_SUCCESS_MESSAGE, type: 'success' });
    } catch {
      showErrorToast({ title: PERMISSION_PASTE_ERROR_MESSAGE, type: 'error' });
    }
  }

  function paste() {
    if (!canPaste.value) return;

    const targets = selectionStore.resolvePasteTargets(formBuilderStore.elements);
    const replacesExisting = targets.some((target) =>
      permissionsStore.isFieldPermissioned(target.fieldId)
    );

    if (!replacesExisting) {
      commitPaste();
      return;
    }

    const { open, close } = useModal({
      component: ConfirmDeleteModal,
      attrs: {
        icon: DangerIcon,
        iconAlt: 'Alerta',
        title: permissionPasteReplaceTitle(targets.length),
        description: '',
        onClose() {
          close();
        },
        onConfirm() {
          close();
          commitPaste();
        },
      },
    });

    open();
  }

  return { canCopy, canPaste, copy, paste };
}
